import moment from "moment";
import { useNavigate } from "react-router-dom";
import {
  getDiningModeLabel,
  MODE_DELIVERY,
} from "../../../constants/constants";
import CloseIcon from "../../../images/CloseIcon_btn.svg";
import restuarntNameExample from "../../../images/restuarntNameExample.png";
import WishListIcon from "../../../images/WishListIcon.svg";
import { RestaurantCart } from "../../../interfaces/Catalogue";
import { formatDate } from "../../../utils/dateUtils";
import OrderDetails from "../../shared/OrderDetails/OrderDetails";
import PaymentInfo from "../PaymentInfo/PaymentInfo";
import "./InvoiceCommand.scss";

export default function InvoiceCommand({
  command,
  qrcode,
  restaurantCart,
  PrepareFor,
  discountAmount,
  totalLoyaltyPtsConsomed,
}: {
  command?: any;
  qrcode: string;
  restaurantCart?: RestaurantCart;
  PrepareFor: string | null;
  discountAmount: number;
  totalLoyaltyPtsConsomed: number;
}) {
  const navigate = useNavigate();
  const parseDetailCommande = JSON.parse(command?.detailCommande || "{}");
  const { formattedDate, formattedTime } = formatDate(PrepareFor || "");

  const convertHexToByteArray = (hexString: string) => {
    const byteCharacters = atob(hexString || "");
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    return new Uint8Array(byteNumbers);
  };

  let byteArray = convertHexToByteArray(qrcode);
  const blob = new Blob([byteArray], { type: "image/jpeg" });
  const imageUrl = URL.createObjectURL(blob);

  return (
    <div className="InvoiceCommand">
      <div className="InvoiceContainer">
        <button className="btn-cmd" onClick={() => navigate("/mes-commandes")}>
          <img src={CloseIcon} alt="Remove and Navigate" />
        </button>
        <div className="invoice-header">
          <img className="restaurant-img" src={restuarntNameExample} alt="" />
          <p className="restaurant-name">{command?.nomRestaurant}</p>
          <img src={WishListIcon} alt="" className="wishList" />
        </div>
        <div className="invoice-body">
          <div>
            {command?.status === "cashPayment" ? (
              <p className="message">
                Dirigez-vous vers la caisse pour le règlement.
              </p>
            ) : command?.diningMode !== MODE_DELIVERY ? (
              <p className="message">
                Veuillez récupérer votre bipeur à la caisse.
              </p>
            ) : null}
          </div>

          <div className="QrCode">
            <p>Votre ticket</p>
            {command?.status === "cashPayment" ? (
              <img className="qrCodeImg" src={imageUrl} alt="" />
            ) : null}

            {command && (
              <div className="Commandinfo">
                <p className="command-number">
                  Commande N° {command?.referenceCommande}
                </p>
                {/* <p className="command-time">A emporter : entre 19:30 et 20:00 </p> */}
              </div>
            )}
          </div>

          {command && (
            <div className="Ticket-details">
              <div className="ticket-header">
                {/* <p className="title-ticket">Votre ticket</p> */}
                <div>
                  <p className="time-ticket">
                    Aujourd’hui à {moment().format("HH:mm")}
                  </p>
                  <p className="delivery-ticket">
                    {getDiningModeLabel(command.diningMode)}
                    {PrepareFor &&
                      `, prêt à ${formattedTime} le ${formattedDate}`}
                  </p>
                </div>
              </div>

              <div style={{ paddingBottom: 20 }}>
                {parseDetailCommande && (
                  <OrderDetails
                    categories={parseDetailCommande}
                    orderType={restaurantCart?.mode || 0}
                    canApplyArticleDiscount={false}
                    canEditQuantity={false}
                  />
                )}
              </div>
            </div>
          )}
        </div>
        {command && (
          <PaymentInfo
            supTotal={command?.totalPrix || 0}
            discountAmount={discountAmount}
            fees={command?.deliveryFee || 0}
            finalTotal={command?.totalPrix + command?.deliveryFee || 0}
            totalLoyaltyPtsConsomed={totalLoyaltyPtsConsomed || 0}
          />
        )}

        {command?.diningMode == MODE_DELIVERY && command?.deliveryUrl && (
          <div className="footer-details">
            <button
              onClick={() => window.open(command?.deliveryUrl, "_blank")}
              className="btn-track"
            >
              Suivre votre commande
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
